import { Box, Typography, useTheme, Grid, Container } from "@mui/material";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { images } from 'config/images';
import { Link } from 'react-router-dom';
import { blogPosts } from "./data/blogPost";
import "./style/style.css";

export const Blog = () => {
   const theme = useTheme();
   return (
      <>
         <Grid container>
            <Grid item xs={12} md={6} sx={{ display: "flex" }}>
               <Box
                  component={"img"}
                  src={images.home.hero}
                  alt={"Pricing"}
                  width={"100%"}
                  maxHeight={550}
                  sx={{ objectFit: "cover" }}
               />
            </Grid>
            <Grid item xs={12} md={6} sx={{ display: "flex" }}>
               <Box
                  width={"100%"}
                  sx={{ backgroundColor: theme.palette.primary.dark }}
                  p={theme.spacing(4)}
                  color={theme.palette.common.white}
                  display={"flex"}
                  flexDirection={"column"}
                  justifyContent={"center"}
               >
                  <Typography variant="h1">
                     Blog
                  </Typography>
               </Box>
            </Grid>
         </Grid>

         <Box component={"section"} my={5}>
            <Container>
               <Grid
                  container
                  rowSpacing={{ xs: 3, md: 1 }}
                  columnSpacing={3}
                  rowGap={2}
                  marginTop={"3rem"}
                  paddingBottom={"3rem"}
               >
                  {blogPosts.map(({ slug, meta, excerpt }) => (
                     <Grid
                        item
                        xs={12}
                        md={6}
                        lg={4}
                        key={slug}
                        display={"flex"}
                        flexDirection={"column"}
                     >
                        <div>
                           <Link className="blog-header" to={slug}>
                              {meta.title}
                           </Link>
                        </div>
                        <div className="blog-excerpt">
                           <Typography dangerouslySetInnerHTML={{ __html: excerpt }} />

                           <Link to={slug}>
                              <Box component={"span"} display="flex" alignItems="center" gap={1}>
                                 Read More
                                 <Box component="span" color="primary.main">
                                    <span role="img" aria-label="arrow">
                                       <ArrowForwardIcon />
                                    </span>
                                 </Box>
                              </Box>
                           </Link>
                        </div>
                     </Grid>
                  ))}
               </Grid>
            </Container>
         </Box>
      </>
   );
};
